function disableAll(radioList, i) {
  radioList.forEach((button, j) => {
    // const selector = button.children[0]; // Will use eventually to apply styles
    // const radioButton = selector.children[1];
    // const radio = radioButton.children[1];
    const media = button.children[1];
    const text = button.children[2];

    // button.classList.remove('radio-Button-temp');
    // selector.classList.remove("radio-Button-temp");
    // media.classList.remove('radio-Button-temp');
    text.children[0].classList.remove('radio-Button-temp');
    if (i === j) text.children[0].classList.add('selected-temp');
    button.classList.add('option-made');
    // selector.classList.add("option-made");
    media.classList.add('option-made');
    text.classList.add('option-made');
    // radioList.getElementsByClassName('cx-component cx-list-item cx-cta-link cx-clickable option-made cx-selected')
    // console.log('what are we getting for radioList after selected Now', radioList)
  });
}

function startRadio(radioList) {
  radioList.forEach((button, i) => {
    const selector = button.children[0]; // Will use eventually to apply styles
    const radioButton = selector.children[1];
    const radio = radioButton.children[1];
    const media = button.getElementsByClassName('cx-media cx-cta-link')[0];
    const text = button.getElementsByClassName('cx-text cx-cta-link')[0];
    const submitArray = document.getElementsByClassName('cx-button cx-submit');

    setTimeout(() => {
      radio.setAttribute('style', 'pointer-events: none;');
      // button.classList.add('radio-Button-temp');
      // selector.classList.add("radioButton");
      // media.classList.add('radio-Button-temp');
      text.children[0].classList.add('radio-Button-temp');
      // text
    }, 5);

    button.addEventListener('click', () => {
      radio.click();
      disableAll(radioList, i);
      submitArray[submitArray.length - 1].click();
      submitArray[submitArray.length - 1].setAttribute('style', 'display: none !important;');
    });

    // selector.addEventListener('click', () => {
    //   radio.click();
    //   disableAll(radioList, i);
    //   submitArray[submitArray.length - 1].click();
    //   submitArray[submitArray.length - 1].setAttribute('style', 'display: none !important;');
    // });

    media.addEventListener('click', () => {
      // console.log("clicked MEDIA on button ", x);
      radio.click();
      disableAll(radioList, i);
      submitArray[submitArray.length - 1].click();
      submitArray[submitArray.length - 1].setAttribute('style', 'display: none !important;');
    });

    text.addEventListener('click', () => {
      radio.click();
      disableAll(radioList, i);
      submitArray[submitArray.length - 1].click();
      submitArray[submitArray.length - 1].setAttribute('style', 'display: none !important;');
    });
  });
}

export default { startRadio };
